module.exports = __webpack_public_path__ + "static/ilustration-82816b30177de6c538e2f51e05a5f4d8.svg";